module.exports = __webpack_public_path__ + "assets/30c2f8c4e0f4f1e9f83815765564c9b8.png";